import './App.scss';
import Terms from "./components/Terms/Terms";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Info from "./components/Info/Info";
import smoothscroll from 'smoothscroll-polyfill';
import {FunctionComponent, useRef} from "react";
import "swiper/css";
import useOnScreen from "./hooks/useOnScreen";

smoothscroll.polyfill();

const App:FunctionComponent = () => {
    const infoRef = useRef<HTMLParagraphElement>(null);
    const infoVisible = useOnScreen(infoRef);
    const isMobile = window.innerWidth < 768;

    return (
        <div className="App">
            <Header showNav={!(isMobile || infoVisible || window.scrollY > 3 * window.innerHeight)}/>
            <Info visibleRef={infoRef}/>
            {/*<Terms/>*/}
            <Footer/>
        </div>
    );
}

export default App;
